import React from "react";
import "./Footer.css";
import footerimage from "./SVGS/Group 48095660.png";
import { Link } from "react-router-dom";


function Footer() {
  return (
    <div>
      <div className="container-fluid footer-div1">
        <div className="container-fluid footer-div2">
          <img src={footerimage} className="footerimg" />
        </div>
        <div className="container-fluid footer-div-3">
          <div className="row">
            <div className="col-lg-3 col-sm-6 col-12 footer-logo-div">
              <Link className="footer-logo1 mx-auto" to="/">
              <svg
                className="footer-logo1 mx-auto"
                width="100"
                height="40"
                viewBox="0 0 122 47"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M60.6288 32.5384L68.787 10.4385H75.368L83.5558 32.5384H76.6913L75.6102 29.2952H68.1313L67.0502 32.5384H60.6288ZM71.0437 20.5167L69.5905 24.8409H74.1628L72.7746 20.5167L71.9416 17.6752H71.8826C71.5695 18.8448 71.2918 19.7959 71.0437 20.5167Z"
                  fill="#3033B5"
                />
                <path
                  d="M91.4417 32.9401C88.6829 32.9401 86.6212 32.2194 85.2625 30.778C83.9037 29.3366 83.2244 27.4993 83.2244 25.2781V23.5767H89.1909V25.3372C89.1909 26.82 89.8526 27.5643 91.17 27.5643C92.446 27.5643 93.084 26.8436 93.084 25.4022V10.4385H99.5409V25.6148C99.5409 27.6352 99.0328 29.242 98.0285 30.4353C96.5871 32.1072 94.3895 32.9401 91.4417 32.9401Z"
                  fill="#3033B5"
                />
                <path
                  d="M102.046 32.5384V10.4385H108.502V18.5377H115.302V10.4385H121.759V32.5384H115.302V23.8839H108.502V32.5384H102.046Z"
                  fill="#3033B5"
                />
                <path
                  d="M0 46.5333L27.5526 0L35.2441 13.1914L27.1095 27.2217H16.8718L5.27539 46.5333H0Z"
                  fill="#3033B5"
                />
                <path
                  d="M20.1159 31.2979H25.5212L16.3705 46.5333H10.9238L20.1159 31.2979Z"
                  fill="#3033B5"
                />
                <path
                  d="M43.4614 5.31084L45.6708 6.66956L22.094 46.8582H27.6884L49.6229 8.70174L51.9977 10.1727V0L43.4614 5.31084Z"
                  fill="#FFB532"
                />
                <path
                  d="M43.6974 28.3027L33.1348 46.8582H54.4667L43.6974 28.3027Z"
                  fill="#3033B5"
                />
                <path
                  d="M62.2059 37.1816H64.2676L65.8449 46.8522H64.3267L64.0491 44.9323V44.9618H62.3241L62.0464 46.8522H60.6345L62.2059 37.1816ZM63.8659 43.6503L63.1866 38.8712H63.157L62.4954 43.6503H63.8659Z"
                  fill="black"
                />
                <path
                  d="M67.8474 46.3738C67.4634 45.9603 67.2744 45.3755 67.2744 44.6193V39.4207C67.2744 38.6646 67.4634 38.0797 67.8474 37.6662C68.2314 37.2527 68.7867 37.0459 69.5134 37.0459C70.24 37.0459 70.7953 37.2527 71.1793 37.6662C71.5633 38.0797 71.7523 38.6646 71.7523 39.4207V40.4427H70.3168V39.3262C70.3168 38.7295 70.0628 38.4283 69.5547 38.4283C69.0467 38.4283 68.7926 38.7295 68.7926 39.3262V44.7315C68.7926 45.3223 69.0467 45.6177 69.5547 45.6177C70.0628 45.6177 70.3168 45.3223 70.3168 44.7315V43.2547H71.7523V44.6252C71.7523 45.3814 71.5633 45.9662 71.1793 46.3797C70.7953 46.7933 70.24 47 69.5134 47C68.7867 46.9941 68.2314 46.7874 67.8474 46.3738Z"
                  fill="black"
                />
                <path
                  d="M73.9967 46.3738C73.6127 45.9603 73.4237 45.3755 73.4237 44.6193V39.4207C73.4237 38.6646 73.6127 38.0797 73.9967 37.6662C74.3807 37.2527 74.936 37.0459 75.6627 37.0459C76.3893 37.0459 76.9446 37.2527 77.3286 37.6662C77.7126 38.0797 77.9016 38.6646 77.9016 39.4207V40.4427H76.4661V39.3262C76.4661 38.7295 76.2121 38.4283 75.704 38.4283C75.196 38.4283 74.9419 38.7295 74.9419 39.3262V44.7315C74.9419 45.3223 75.196 45.6177 75.704 45.6177C76.2121 45.6177 76.4661 45.3223 76.4661 44.7315V43.2547H77.9016V44.6252C77.9016 45.3814 77.7126 45.9662 77.3286 46.3797C76.9446 46.7933 76.3893 47 75.6627 47C74.936 46.9941 74.3807 46.7874 73.9967 46.3738Z"
                  fill="black"
                />
                <path
                  d="M80.1523 46.3562C79.7565 45.9308 79.5557 45.3342 79.5557 44.5603V39.4739C79.5557 38.7 79.7565 38.1034 80.1523 37.678C80.5481 37.2527 81.1212 37.04 81.8655 37.04C82.6098 37.04 83.1829 37.2527 83.5787 37.678C83.9745 38.1034 84.1753 38.7 84.1753 39.4739V44.5603C84.1753 45.3342 83.9745 45.9308 83.5787 46.3562C83.1829 46.7815 82.6098 46.9942 81.8655 46.9942C81.1212 46.9942 80.5481 46.7815 80.1523 46.3562ZM82.6571 44.6607V39.3794C82.6571 38.7414 82.3913 38.4283 81.8714 38.4283C81.3456 38.4283 81.0857 38.7473 81.0857 39.3794V44.6607C81.0857 45.2987 81.3456 45.6118 81.8714 45.6118C82.3913 45.6118 82.6571 45.2928 82.6571 44.6607Z"
                  fill="black"
                />
                <path
                  d="M86.5562 46.3619C86.1663 45.9425 85.9773 45.3399 85.9773 44.5601V37.1816H87.4955V44.6723C87.4955 45.0032 87.5605 45.2454 87.6964 45.3931C87.8323 45.5407 88.0213 45.6116 88.2694 45.6116C88.5175 45.6116 88.7066 45.5348 88.8424 45.3931C88.9783 45.2454 89.0433 45.0032 89.0433 44.6723V37.1816H90.5084V44.5601C90.5084 45.3458 90.3134 45.9425 89.9294 46.3619C89.5454 46.7813 88.9783 46.9881 88.2458 46.9881C87.5014 46.994 86.9402 46.7813 86.5562 46.3619Z"
                  fill="black"
                />
                <path
                  d="M92.411 37.1816H94.3191L95.796 42.971H95.8255V37.1816H97.1783V46.8522H95.6188L93.7934 39.7928H93.7638V46.8522H92.411V37.1816Z"
                  fill="black"
                />
                <path
                  d="M100.333 38.564H98.744V37.1816H103.44V38.564H101.851V46.8581H100.333V38.564Z"
                  fill="black"
                />
                <path
                  d="M105.543 37.1816H107.605L109.182 46.8522H107.664L107.386 44.9323V44.9618H105.661L105.383 46.8522H103.972L105.543 37.1816ZM107.197 43.6503L106.518 38.8712H106.488L105.827 43.6503H107.197Z"
                  fill="black"
                />
                <path
                  d="M110.736 37.1816H112.644L114.121 42.971H114.151V37.1816H115.504V46.8522H113.944L112.119 39.7928H112.089V46.8522H110.736V37.1816Z"
                  fill="black"
                />
                <path
                  d="M118.652 38.564H117.063V37.1816H121.76V38.564H120.171V46.8581H118.652V38.564Z"
                  fill="black"
                />
              </svg>
              </Link>
              <p className="footer-text1 mt-3">A innovative platform </p>
            </div>
            <div className="col-lg-3 col-sm-6 col-12">
              <p className="footer-text1"><a href="mailto:info@ajhaccountant.com" className="footer-text1">info@ajhaccountant.com</a></p>
              <p className="footer-text1"><a href="tel:+44 01204 840303" className="footer-text1 mt-3">+44 01204 840303 </a></p>
            </div>
            <div className="col-lg-3 col-sm-6 col-12 mt-lg-0 mt-sm-2 mt-0">
              <p className="footer-text2">Office 8, 1st Floorm Haslam House</p>
              <p className="footer-text2 mt-3">
                105 Chorley Old Road, Bolton BL1 3AS
              </p>
            </div>
            <div className="col-lg-3 col-sm-6 col-12 mt-lg-0 mt-sm-2 mt-0">
              <p className="footer-text1 text-center">Follow Us</p>
              <div className="footer-text1 mt-3 d-flex justify-content-center">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 9V7.2C14 6.42 14.18 6 15.44 6H17V3H14.6C11.6 3 10.4 4.98 10.4 7.2V9H8V12H10.4V21H14V12H16.64L17 9H14Z"
                    fill="#01182F"
                  />
                </svg>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.8046 8.27523C17.4011 8.27523 17.8846 7.7917 17.8846 7.19523C17.8846 6.59877 17.4011 6.11523 16.8046 6.11523C16.2081 6.11523 15.7246 6.59877 15.7246 7.19523C15.7246 7.7917 16.2081 8.27523 16.8046 8.27523Z"
                    fill="#01182F"
                  />
                  <path
                    d="M12.0004 7.37891C11.0864 7.37891 10.1928 7.64995 9.43284 8.15777C8.67284 8.66559 8.08049 9.38737 7.7307 10.2318C7.38091 11.0763 7.28939 12.0055 7.46771 12.902C7.64603 13.7985 8.08619 14.622 8.73251 15.2683C9.37884 15.9146 10.2023 16.3548 11.0988 16.5331C11.9953 16.7114 12.9245 16.6199 13.769 16.2701C14.6134 15.9203 15.3352 15.328 15.843 14.568C16.3509 13.808 16.6219 12.9145 16.6219 12.0004C16.6219 10.7747 16.135 9.59921 15.2683 8.73251C14.4016 7.86581 13.2261 7.37891 12.0004 7.37891ZM12.0004 15.0004C11.4071 15.0004 10.827 14.8245 10.3337 14.4948C9.84035 14.1652 9.45583 13.6966 9.22877 13.1485C9.00171 12.6003 8.9423 11.9971 9.05805 11.4151C9.17381 10.8332 9.45953 10.2986 9.87909 9.87909C10.2986 9.45953 10.8332 9.17381 11.4151 9.05805C11.9971 8.94229 12.6003 9.0017 13.1485 9.22877C13.6966 9.45583 14.1652 9.84035 14.4948 10.3337C14.8245 10.827 15.0004 11.4071 15.0004 12.0004C15.0004 12.7961 14.6843 13.5591 14.1217 14.1217C13.5591 14.6843 12.7961 15.0004 12.0004 15.0004Z"
                    fill="#01182F"
                  />
                  <path
                    d="M12 4.6215C14.403 4.6215 14.688 4.6305 15.6368 4.674C16.2074 4.68077 16.7726 4.78555 17.3077 4.98375C17.696 5.13352 18.0486 5.36291 18.3428 5.65716C18.6371 5.95141 18.8665 6.304 19.0163 6.69225C19.2145 7.2274 19.3192 7.79262 19.326 8.36325C19.3695 9.312 19.3785 9.597 19.3785 12.0007C19.3785 14.4045 19.3695 14.688 19.326 15.6368C19.3192 16.2074 19.2145 16.7726 19.0163 17.3077C18.8665 17.696 18.6371 18.0486 18.3428 18.3428C18.0486 18.6371 17.696 18.8665 17.3077 19.0163C16.7726 19.2145 16.2074 19.3192 15.6368 19.326C14.688 19.3695 14.403 19.3785 12 19.3785C9.597 19.3785 9.312 19.3695 8.36325 19.326C7.79262 19.3192 7.2274 19.2145 6.69225 19.0163C6.304 18.8665 5.95141 18.6371 5.65716 18.3428C5.36291 18.0486 5.13352 17.696 4.98375 17.3077C4.78555 16.7726 4.68077 16.2074 4.674 15.6368C4.6305 14.688 4.6215 14.403 4.6215 12C4.6215 9.597 4.6305 9.312 4.674 8.36325C4.68077 7.79262 4.78555 7.2274 4.98375 6.69225C5.13352 6.304 5.36291 5.95141 5.65716 5.65716C5.95141 5.36291 6.304 5.13352 6.69225 4.98375C7.2274 4.78555 7.79262 4.68077 8.36325 4.674C9.312 4.6305 9.597 4.6215 12 4.6215ZM12 3C9.55575 3 9.249 3.0105 8.289 3.054C7.54258 3.06907 6.80412 3.21058 6.105 3.4725C5.50704 3.70372 4.96399 4.05733 4.51066 4.51066C4.05733 4.96399 3.70372 5.50704 3.4725 6.105C3.21049 6.80435 3.06899 7.54308 3.054 8.28975C3.0105 9.24975 3 9.555 3 12C3 14.445 3.0105 14.751 3.054 15.711C3.06907 16.4574 3.21058 17.1959 3.4725 17.895C3.70372 18.493 4.05733 19.036 4.51066 19.4893C4.96399 19.9427 5.50704 20.2963 6.105 20.5275C6.80435 20.7895 7.54308 20.931 8.28975 20.946C9.24975 20.9895 9.55575 21 12 21C14.4443 21 14.751 20.9895 15.711 20.946C16.4577 20.931 17.1964 20.7895 17.8958 20.5275C18.4937 20.2963 19.0368 19.9427 19.4901 19.4893C19.9434 19.036 20.297 18.493 20.5282 17.895C20.79 17.1956 20.9313 16.4569 20.946 15.7103C20.9895 14.7503 21 14.445 21 12C21 9.555 20.9895 9.249 20.946 8.289C20.9309 7.54258 20.7894 6.80412 20.5275 6.105C20.2963 5.50704 19.9427 4.96399 19.4893 4.51066C19.036 4.05733 18.493 3.70372 17.895 3.4725C17.1956 3.21075 16.4569 3.0695 15.7103 3.05475C14.7503 3.00975 14.445 3 12 3Z"
                    fill="#01182F"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container footer-div4">
        <p className="footer-text3">AJH Accountant. All rights reserved 2022</p>
      </div>
    </div>
  );
}

export default Footer;
